import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LoadingProvider, useLoading } from "./hooks/useLoading";
import { CurrentUserProvider } from "./hooks/useCurrentUser";
import Loading from "./components/Loading";
import Login from "./pages/admin/Login";
import AdminGroups from "./pages/admin/Groups";
import AdminGroupProfile from "./pages/admin/GroupProfile";
import AdminGroupPortal from "./pages/admin/GroupPortal";
import AdminResults from "./pages/admin/Results";
import AdminAverage from "./pages/admin/Average";
import AdminJudgingSheet from "./pages/admin/JudgingSheet";
import AdminUsers from "./pages/admin/Users";
import AdminSummary from "./pages/admin/Summary";
import RequireAuth from "./components/RequireAuth";
import RequirePortalAuth from "./components/RequirePortalAuth";
import GroupEntry from "./pages/user/form/groupEntry/EntryForm";
import GroupEntryComplete from "./pages/user/form/groupEntry/Complete";
import SongEntryComplete from "./pages/user/form/songEntry/Complete";
import PortalLogin from "./pages/user/portal/PortalLogin";
import Portal from "./pages/user/portal/Portal";
import PublicResultPageWrapper from "./pages/user/Results/PublicResultPageWrapper";
import PublicResultPage from "./pages/user/Results/PublicResultPage";
// inport GroupPage form
// inport GroupPageEdit form "./pages/user/GroupPage";

const AppRoutes = () => {
  const { isLoading } = useLoading();

  return (
    <>
      <Loading isLoading={isLoading} />

      <BrowserRouter>
        <Routes>
          <Route path="/admin/login" element={<Login />} />

          <Route path="/group_entry" element={<GroupEntry />} />
          <Route
            path="/entry/group_complete"
            element={<GroupEntryComplete />}
          />
          <Route
            path="/song_entry"
            element={<Navigate to="/portal/login" replace />}
          />
          <Route path="/entry/song_complete" element={<SongEntryComplete />} />

          <Route path="/portal/login" element={<PortalLogin />} />
          <Route
            path="/portal"
            element={
              <RequirePortalAuth>
                <Portal />
              </RequirePortalAuth>
            }
          />

          <Route path="/:id" element={<PublicResultPageWrapper />} />
          <Route path="/result/:id" element={<PublicResultPage />} />

          <Route
            path="/admin/groups"
            element={
              <RequireAuth>
                <AdminGroups />
              </RequireAuth>
            }
          />

          <Route
            path="/admin/group-portal"
            element={
              <RequireAuth>
                <AdminGroupProfile />
              </RequireAuth>
            }
          />

          <Route
            path="/admin/group-portal/:groupName"
            element={
              <RequireAuth>
                <AdminGroupPortal />
              </RequireAuth>
            }
          />

          <Route
            path="/admin/results"
            element={
              <RequireAuth>
                <AdminResults />
              </RequireAuth>
            }
          />

          <Route
            path="/admin/average"
            element={
              <RequireAuth>
                <AdminAverage />
              </RequireAuth>
            }
          />

          <Route
            path="/admin/judging-sheet"
            element={
              <RequireAuth>
                <AdminJudgingSheet />
              </RequireAuth>
            }
          />

          <Route
            path="/admin/summary"
            element={
              <RequireAuth>
                <AdminSummary />
              </RequireAuth>
            }
          />

          <Route
            path="/admin/users"
            element={
              <RequireAuth>
                <AdminUsers />
              </RequireAuth>
            }
          />
        </Routes>
      </BrowserRouter>
    </>
  );
};

const App = () => {
  return (
    <LoadingProvider>
      <CurrentUserProvider>
        <AppRoutes />
      </CurrentUserProvider>
    </LoadingProvider>
  );
};

export default App;
